import { render, staticRenderFns } from "./cardsmenu.vue?vue&type=template&id=0a10cb66&scoped=true"
import script from "./cardsmenu.vue?vue&type=script&lang=js"
export * from "./cardsmenu.vue?vue&type=script&lang=js"
import style0 from "./cardsmenu.vue?vue&type=style&index=0&id=0a10cb66&prod&scoped=true&lang=css"
import style1 from "./cardsmenu.vue?vue&type=style&index=1&id=0a10cb66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10cb66",
  null
  
)

export default component.exports